<script>
    // https://github.com/picqer/php-barcode-generator
    import {API_URL} from "../lib/constants.js";
    import PageHeader from "../components/PageHeader.svelte";
    import {formatDate} from "../lib/lib.js";
    import Alert from "../stores/alerts.js";

    let codes = "";
    let date = "";
    let links = [];

    const generateLinks = () => {
        if (!date) {
            Alert.warning("Ημερομηνία", "Δεν έχετε ορίσει ημερομηνία και ώρα!");
            return;
        }
        codes = codes.trim();
        if (!codes) {
            Alert.warning("Κωδικοί", "Δεν έχει οριστεί τους κωδικούς για τα barcodes!");
            return;
        }
        // let url = API_URL.replace("admin.", "").replace("/app", "/barcode");
        let url = "https://haciendacafe.com/barcode";
        links = [];

        let tstamp = date ? "/" + formatDate(date, "ymdHi") : "";
        let arr = codes.split("\n");

        arr.map(item => {
            let code = item.trim();
            if (code) {
                links.push(`${url}${tstamp}/${code}.jpg`);
            }
        });
    }
</script>

<PageHeader title="Barcodes"/>

<div class="row">
    <div class="col-md-6">
        <div class="panel panel-default mb-5">
            <div class="panel-heading">
                Δημιουργία Barcodes
            </div>
            <div class="panel-body panel-pad">
                <div class="form-group">
                    <label>Ημερομηνία</label>
                    <input type="datetime-local" class="form-control" bind:value={date}>
                </div>
                <div class="form-group">
                    <textarea style="width:100%;" rows="20" bind:value={codes}></textarea>
                </div>
                <button class="btn btn-primary" on:click={generateLinks}>Δημιουργία</button>
            </div>
        </div>
    </div>
    {#if links.length}
        <div class="col-md-6">
            <div class="panel panel-default">
                <div class="panel-heading">
                    Αποτελέσματα
                </div>
                <div class="panel-body panel-pad">
                    {#each links as link}
                        <div>
                            <a href="{link}" target="_blank">{link}</a>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    {/if}
</div>